import { render } from "./pay-finish.vue?vue&type=template&id=1d2b7e82&scoped=true"
import script from "./pay-finish.vue?vue&type=script&lang=js"
export * from "./pay-finish.vue?vue&type=script&lang=js"

import "./pay-finish.vue?vue&type=style&index=0&id=1d2b7e82&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\inner-training\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2b7e82"]])

export default __exports__